import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { getFormatDate } from "~/libs/getFormatDate";

export const getEditorTrustedPersonsColumns = (
  t: TFunction,
  options: string[],
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`trustedPersons.table.${option}`),
      dataIndex: option,
      key: option,
    };

    // Special render for date field - format date
    if (option === "date") {
      return {
        ...baseColumn,
        render: (value: any) => <span>{getFormatDate(value)}</span>,
      };
    }

    // Special render for active field - "Да/Нет"
    if (option === "active") {
      return {
        ...baseColumn,
        render: (value: any) => <span>{value ? "Да" : "Нет"}</span>,
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
